import { Injectable, inject } from '@angular/core';

import { Oauth2Service, UserService } from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';
import { PtoService } from '@services/pto.service';

import { tunnelRoutes } from '@tunnel/routes';

import { PtoStep } from '@shared/stepper/steps/pto.step';

import { Observable, of } from 'rxjs';

import { Step } from './step';

@Injectable({
    providedIn: 'root',
})
export class SignupStep extends Step {
    public static readonly key: string = 'signup';
    public isFormValid: boolean = false;
    public isValid: boolean;
    public shortLabel: string = 'Coordonnées';
    public label: string = 'Compléter les informations';
    public next: Step;
    public routerLink: string = `/tunnel/${tunnelRoutes.signup}`;
    public hasReminder = true;
    public icon: string = 'tri-identity';

    protected ptoService = inject(PtoService);
    protected cartService = inject(MainCartService);
    protected oauth2Service = inject(Oauth2Service);
    protected ptoStep: PtoStep = inject(PtoStep);
    private userService = inject(UserService);

    constructor() {
        super();
        this._isLoaded.next(true);
    }

    public canAccess(): Observable<boolean> {
        const storedSiren = this.userService.getStoredUserData()?.siren?.data;
        const hasProduct = this.cartService.getQuote().products.length > 0;
        const isBaseResult =
            hasProduct && (this.cartService.cartModel.isPro && !this.oauth2Service.isConnected ? !!storedSiren : true);

        return of(isBaseResult);
    }

    public canDisplay(): boolean {
        return true;
    }

    public getReminderData(): string {
        return this.userService.getStoredUserData().data?.email;
    }
}
